import { createClient } from '@supabase/supabase-js'
import { SUPABASE_CONFIG, isSupabaseConfigured } from '@/config/supabase'

const supabaseUrl = SUPABASE_CONFIG.url
const supabaseAnonKey = SUPABASE_CONFIG.anonKey

if (!isSupabaseConfigured()) {
  if (import.meta.env.DEV) {
    console.error('Backend non configurato correttamente.')
  }
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
}) 